import { Box, styled } from "@material-ui/core";
import {
  EPOCUS_BORDER,
  EPOCUS_ICON_ACTIVE,
  EPOCUS_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../../_lib/epocus-palette";

const MAX_DOTS = 8;

const Row = styled(Box)({ display: "flex", gap: 4, alignItems: "center" });

const Dot = styled("span")({
  width: 6,
  height: 6,
  borderRadius: "50%",
  backgroundColor: EPOCUS_BORDER,
  transition: "all .3s",
});

const DONE = { backgroundColor: EPOCUS_ICON_ACTIVE } as const;
const CURRENT = {
  backgroundColor: EPOCUS_PRIMARY,
  width: 16,
  borderRadius: 3,
} as const;

const Count = styled("span")({
  fontSize: rem(11.5),
  fontWeight: 600,
  color: EPOCUS_TEXT_SECONDARY,
  fontVariantNumeric: "tabular-nums",
});

export const ProgressDots: FC<{ step: number; total: number }> = ({
  step,
  total,
}) =>
  total > MAX_DOTS ? (
    <Count aria-label={`Step ${step + 1} of ${total}`}>
      {`${step + 1} / ${total}`}
    </Count>
  ) : (
    <Row
      role="progressbar"
      aria-valuenow={step + 1}
      aria-valuemin={1}
      aria-valuemax={total}
      aria-label="Setup progress"
    >
      {Array.from({ length: total }, (_, index) => (
        <Dot
          key={index}
          style={index < step ? DONE : index === step ? CURRENT : undefined}
        />
      ))}
    </Row>
  );
